var chunkMapping = {
	"0": [
		4722
	],
	"3": [
		4194
	],
	"74": [
		5136
	],
	"153": [
		5215
	],
	"154": [
		5216
	],
	"157": [
		5219
	],
	"158": [
		5220
	],
	"159": [
		5221
	],
	"160": [
		5222
	],
	"161": [
		5223
	],
	"162": [
		5224
	],
	"163": [
		5225
	],
	"164": [
		5226
	],
	"165": [
		5227
	],
	"166": [
		5228
	],
	"167": [
		5229
	],
	"168": [
		5230
	],
	"169": [
		5231
	],
	"170": [
		5232
	],
	"171": [
		5233
	],
	"172": [
		5234
	],
	"173": [
		5235
	]
};
var idToExternalAndNameMapping = {
	"4194": [
		"default",
		"./nuorder-components",
		4017
	],
	"4722": [
		"default",
		"./Containers",
		3796
	],
	"5136": [
		"default",
		"./OrderlessInvoices",
		3796
	],
	"5215": [
		"default",
		"./AsyncEventTracker",
		3796
	],
	"5216": [
		"default",
		"./HostWrapper",
		3796
	],
	"5219": [
		"default",
		"./CheckoutV3",
		3796
	],
	"5220": [
		"default",
		"./CheckoutConfirmation",
		3796
	],
	"5221": [
		"default",
		"./ContactCreditCards",
		3796
	],
	"5222": [
		"default",
		"./AuditDialog",
		3796
	],
	"5223": [
		"default",
		"./InvoiceBlocksOrderDialog",
		3796
	],
	"5224": [
		"default",
		"./InvoiceDialog",
		3796
	],
	"5225": [
		"default",
		"./PaymentDueModal",
		3796
	],
	"5226": [
		"default",
		"./PaymentModal",
		3796
	],
	"5227": [
		"default",
		"./PaymentHistory",
		3796
	],
	"5228": [
		"default",
		"./PaymentConfigurations",
		3796
	],
	"5229": [
		"default",
		"./PaymentPreferences",
		3796
	],
	"5230": [
		"default",
		"./ManagePaymentProcessing",
		3796
	],
	"5231": [
		"default",
		"./MobilePaymentsWrapper",
		3796
	],
	"5232": [
		"default",
		"./Challenge",
		3796
	],
	"5233": [
		"default",
		"./ManagePaymentMethods",
		3796
	],
	"5234": [
		"default",
		"./LightspeedReports",
		3796
	],
	"5235": [
		"default",
		"./ShippingPromotionsListContainer",
		3796
	]
};
var idToRemoteMap = {
	"4194": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 4017
		}
	],
	"4722": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5136": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5215": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5216": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5219": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5220": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5221": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5222": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5223": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5224": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5225": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5226": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5227": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5228": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5229": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5230": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5231": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5232": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5233": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5234": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	],
	"5235": [
		{
			"externalType": "promise",
			"name": "",
			"externalModuleId": 3796
		}
	]
};
__webpack_require__.federation.bundlerRuntimeOptions.remotes = {idToRemoteMap,chunkMapping, idToExternalAndNameMapping, webpackRequire:__webpack_require__};
__webpack_require__.f.remotes = (chunkId, promises) => {
	__webpack_require__.federation.bundlerRuntime.remotes({idToRemoteMap,chunkMapping, idToExternalAndNameMapping, chunkId, promises, webpackRequire:__webpack_require__});
}